<!-- Navigation -->
<treo-vertical-navigation
  [appearance]="'classic'"
  [mode]="isScreenSmall ? 'over' : 'side'"
  [name]="'mainNavigation'"
  [navigation]="defaultNavigation"
  [opened]="!isScreenSmall">
  <div
    treoVerticalNavigationContentHeader
    class="flex justify-center items-center my-5">
    <!-- <div class='logo'> -->
    <img class="w-1/2" [src]="'assets/logo-edwallet.webp'" alt="edwallet" />
    <!-- </div> -->
  </div>
</treo-vertical-navigation>

<!-- Wrapper -->
<div class="wrapper">
  <!-- Header -->
  <div class="header">
    <!-- Navigation toggle button -->
    <button
      mat-icon-button
      aria-label="Menu"
      class="navigation-toggle-button"
      (click)="toggleNavigation('mainNavigation')">
      <mat-icon class="icon-size-17 fa-regular fa-bars"></mat-icon>
    </button>

    <!-- Spacer -->
    <div class="spacer"></div>

    <img
      class="xs:block hidden w-1/2"
      [@zoomIn]
      [src]="'assets/logo-edwallet.webp'"
      alt="edwallet" />

    <!-- Spacer -->
    <div class="spacer"></div>

    <!-- Search -->
    <!-- <search [appearance]="'bar'"></search> -->

    <!-- Shortcuts -->
    <!-- <shortcuts [shortcuts]='data.shortcuts'></shortcuts> -->

    <!-- Messages -->
    <!-- <messages [messages]='data.messages'></messages> -->

    <!-- Notifications -->
    <!-- <notifications [notifications]='data.notifications'></notifications> -->

    <!-- Right -->
    <!-- <button name='' aria-label='Right'
            class='xs:hidden navigation-toggle-button bg-red-100 rounded-md p-1'
            (click)="MDS.makePayment()">
            <mat-icon class="icon-size-17 fa-regular fa-right text-warn-300" matTooltip="{{ 'Right' | translate }}"></mat-icon>
        </button> -->

    <!-- Up -->
    <!-- <button name='' aria-label='Up'
            class='xs:hidden navigation-toggle-button bg-blue-100 rounded-md p-1'
            (click)="MDS.addMoney()">
            <mat-icon class="icon-size-17 fa-regular fa-up text-primary-300" matTooltip="{{ 'Up' | translate }}"></mat-icon>
        </button> -->

    <!-- Down -->
    <!-- <button name='' aria-label='Down'
            class='xs:hidden navigation-toggle-button bg-accent-100 rounded-md p-1'
            (click)="MDS.withdrawMoney()">
            <mat-icon class="icon-size-17 fa-regular fa-down" matTooltip="{{ 'Down' | translate }}"></mat-icon>
        </button> -->

    <!-- Check -->
    <!-- <button mat-icon-button name='' aria-label='Check list'
            class='xs-hidden navigation-toggle-button'>
            <mat-icon class="icon-size-17 fa-regular fa-clipboard-check" matTooltip="{{ 'Check list' | translate }}"></mat-icon>
        </button> -->

    <!-- Money -->
    <!-- <button mat-icon-button name='' aria-label='Money'
            class='xs-hidden navigation-toggle-button'>
            <mat-icon class="icon-size-17 fa-regular fa-circle-dollar" matTooltip="{{ 'Money' | translate }}"></mat-icon>
        </button> -->

    <!-- Notifications -->
    <!-- <button mat-icon-button name='open notifications' aria-label='open notifications'
            class='xs-hidden navigation-toggle-button'>
            <mat-icon class="icon-size-17 fa-regular fa-bell" matTooltip="{{ 'Notifications' | translate }}"></mat-icon>
        </button> -->

    <div class="flex items-center gap-3">            
        <!-- Create request -->
        <ew-button-create-mat-menu></ew-button-create-mat-menu>

        <!-- language -->
        <ew-languages [navbar]="true"></ew-languages>

        <!-- help -->
        <ew-button-help></ew-button-help>

        <!-- user -->
        <user></user>
    </div>    
  </div>

  <!-- Content -->
  <div class="content scroll">
    <!-- *ngIf="true" hack is required here for router-outlet to work correctly. Otherwise,
             it won't register the changes on the layout and won't update the view. -->
    <router-outlet *ngIf="true"></router-outlet>
  </div>

  <!-- Footer -->
  <div class="footer hidden xs:flex">
    <a
      class="w-1/4"
      mat-button
      [@zoomIn]
      [routerLink]="item.link"
      routerLinkActive="active"
      #rla="routerLinkActive"
      *ngFor="let item of defaultNavigation">
      <mat-icon
        class="icon-size-17 fa-regular {{ item.icon }}"
        [class.text-primary]="rla.isActive"></mat-icon>
    </a>
  </div>
</div>
